// extracted by css-extract-rspack-plugin
export default {"base":"Base-module__base__AYc77","shine":"Base-module__shine__tVvUE"};